module.exports = __webpack_public_path__ + "static/media/Trouser Image 1340 x 650.7d4381e7.png";